import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { jwtDecode } from 'jwt-decode';
import 'bootstrap/dist/css/bootstrap.min.css'; // Ensure Bootstrap is imported

//sujay I devloped this page for get all the comment and replies of all users for that logged in User
function ReviewerViewComments() {
    const platformId = localStorage.getItem('platformID');
    const [reviewComments, setReviewComments] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    //const [authorsIds, setAuthorsIds] = useState([]);
    const token = localStorage.getItem('token');
    const API = process.env.REACT_APP_API_BASE_URL;
    let reviewerID = null;

    if (token) {
        const decoded = jwtDecode(token);
        reviewerID = localStorage.getItem('reviewerID');
        // console.log(reviewerID)
    }
    useEffect(() => {
        if (platformId && reviewerID) {
            // console.log(`${API}/api/reviewer-comments/comments/${platformId}/${reviewerID}`)
            axios
                .get(`${API}/api/reviewer-comments/comments/${platformId}/${reviewerID}`)
                .then((res) => {

                    const filteredComments = res.data.map(comment => ({
                        Decision: comment.Decision,
                        Comment: comment.Comment,
                        AuthorReply: comment.AuthorReply,
                        SubmissionTitle: comment.SubmissionTitle,
                        AuthorName: comment.AuthorName, // Include the AuthorName from the backend response
                    }));
                    
                    setReviewComments(filteredComments); // Update state with the filtered data
                })
                .catch((err) => {
                    console.error('Error fetching comments:', err);
                });
        }
    }, [platformId, reviewerID]);

    // Filter reviewComments by searchTerm matching AuthorName or SubmissionTitle
    const filtered = reviewComments.filter(c =>
        c.AuthorName.toLowerCase().includes(searchTerm.toLowerCase()) ||
        c.SubmissionTitle.toLowerCase().includes(searchTerm.toLowerCase()) 
    );

    return (
        <div className="container mt-5 ml-2">
            <h3 className="page-title mb-4">Reviewer Comments</h3>

            {/* Search Box */}
            <div className="mb-3">
                <input
                    type="text"
                    className="form-control"
                    placeholder="Search by Author or Submission Title"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                />
            </div>

            {/* Display Comments */}
            {filtered.length > 0 ? (
                <div className="table-responsive">
                    <table className="table table-bordered table-hover align-middle">
                        <thead className="thead-light">
                            <tr>
                                <th scope="col">Submission Title</th>
                                <th scope="col">Author</th>
                                <th scope="col">Decision</th>
                                <th scope="col">Comment</th>
                                <th scope="col">Author Reply</th>
                            </tr>
                        </thead>
                        <tbody>
                            {filtered.map((c, idx) => {
                                if (!c.Comment) return null;
                                const decisionClass =
                                    c.Decision === 'AcceptWithComment'
                                        ? 'text-success fw-semibold'
                                        : 'text-danger fw-semibold';
                                return (
                                    <tr key={c.id ?? idx}>
                                        <td>{c.SubmissionTitle}</td>
                                        <td>{c.AuthorName}</td>
                                        <td className={decisionClass}>
                                            {c.Decision === "AcceptWithComment" ? "Comment" : ""}
                                        </td>
                                        <td>{c.Comment}</td>
                                        <td className={!c.AuthorReply ? 'text-muted fst-italic' : ''}>
                                            {c.AuthorReply || 'No Reply'}
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            ) : (
                <div className="alert alert-info text-center">No comments available.</div>
            )}
        </div>
    );
}

export default ReviewerViewComments;
